import type { IconSvgObject } from './types';

const CardiganIcon: IconSvgObject = [
  ["path", { d: "M6.5 16L5 21H2L3 6L9 3C10.4175 4.59466 13.5825 4.59466 15 3L21 6L22 21H19L17.5 16", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 9L7 19L8 21H16L17 19L18 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.5 3.5C8.5 3.5 8.5 8 12 9M12 9V21M12 9C15.5 8 15.5 3.5 15.5 3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CardiganIcon;
